import { DOCUMENTS_PATHS } from '@store/skeletor/paths';
import { apiSkeletor } from '@store/skeletor/skeletorApi';
import { extractDataFromResponse } from '@utils/api/extractDataFromResponse';

import { type GetDocumentMovementsApiRequest } from './api.types';
import { type DocumentMovement } from './types';

const documentApi = apiSkeletor.injectEndpoints({
  endpoints: build => ({
    getDocumentMovements: build.query<
      DocumentMovement[],
      GetDocumentMovementsApiRequest
    >({
      query: params => ({
        url: DOCUMENTS_PATHS.MOVEMENTS.BASE,
        params,
        method: 'GET',
      }),
      transformResponse: extractDataFromResponse,
    }),
  }),
});

export const endpoint = documentApi.endpoints.getDocumentMovements;

export const { useGetDocumentMovementsQuery } = documentApi;
